import { render, staticRenderFns } from "./FormPsicotecnico.vue?vue&type=template&id=968188e4&scoped=true"
import script from "./FormPsicotecnico.vue?vue&type=script&lang=js"
export * from "./FormPsicotecnico.vue?vue&type=script&lang=js"
import style0 from "./FormPsicotecnico.vue?vue&type=style&index=0&id=968188e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968188e4",
  null
  
)

export default component.exports